<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{path: '/orders/orderList'}">{{ $t('common.home') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('fund.fundDetail') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <div class="new-box">
          <el-row class="search-row" style="padding: 0">
            <el-col :span="24" class="display-row">
              <div class="search-btn-wrap">
  <!--              <el-button class="search-btn btn-blue" @click="searchList">{{ $t('common.search' || '搜索') }}</el-button>-->
                <el-button size="small" class="search-btn btn-blue" @click="docView('https://oytqc-oss.oss-cn-qingdao.aliyuncs.com/oytqc/instructions/%E3%82%A2%E3%83%9E%E3%82%BE%E3%83%B3%E5%BA%97%E8%88%97%E3%83%90%E3%82%A4%E3%83%B3%E3%83%89%E6%B5%81%E3%82%8C.pdf')">{{ $t('amazon.amazonDoc' || '亚马逊店铺绑定流程') }}</el-button>
                <el-button size="small" class="search-btn btn-green" @click="addItem">{{ $t('add' || '新增') }}</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div slot="table" class="lx-table-wrapper lx-flex-grow-1 lx-hidden lx-relative">
        <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" :data="recordList" border stripe
                  height="100%" :row-style="{height: '40px'}">
          <el-table-column type="index" align="center" :label="$t('wzbg.wz6')" width="60"></el-table-column>
          <el-table-column prop="shopName" align="center" :label="$t('amazon.amazon02') || '店铺名称'">
          </el-table-column>
          <el-table-column prop="activeState" align="center" :label="$t('wzbg.wz5') || '状态'">
            <template v-slot="scope">
              {{ moneyShow(scope.row.activeState) }}
            </template>
          </el-table-column>
          <el-table-column width="260" prop="balance" align="center" :label="$t('handle') || '操作'">
            <template v-slot="{row}">
              <div class="search-btn-wrap table-btn">
                <el-button class="search-btn btn-blue" @click="setGoods(row)">{{ $t('amazon.amazon08' || '商品') }}</el-button>
                <el-button class="search-btn btn-green" @click="setOrder(row)">{{ $t('filter.filter54' || '订单') }}</el-button>
                <el-button class="search-btn btn-deepblue" @click="editItem(row)">{{ $t('update' || '修改') }}</el-button>
                <el-button class="search-btn btn-red" @click="deleteOrder(row)">{{ $t('delete' || '删除') }}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </table-con>
  </div>
</template>

<script>
import tableCon from '@/views/tableContainer';
export default {
  components: { tableCon },
  data () {
    return {
      queryInfo: {
        pageSize: 10,
        pageNum: 1,
      },
      recordList: []
    };
  },
  methods: {
    docView (url) {
      window.open(url, "_blank")
    },
    // 新增
    addItem () {
      this.$modalDialog(() => import('./components/shopItem.vue'), {
        // messageErrorList: this.messageErrorList,
      }).then(
          () => {
            // 新增成功重新拉取数据
            this.searchList()
          },
          () => {
          }
      )
    },
    editItem (row) {
      this.$modalDialog(() => import('./components/shopItem.vue'), {
        editRow: { ...row }
      }).then(
          () => {
            this.searchList()
          },
          () => {
          }
      )
    },
    // 操作商品
    setGoods (row) {
      this.$router.push({
        name: 'amazonGoods',
        query: {
          sellingPartnerId: row.sellingPartnerId
        }
      })
    },
    // 操作订单
    setOrder (row) {
      console.log(row)
      this.$router.push({
        path: '/amazonOrder',
        query: {
          sellingPartnerId: row.sellingPartnerId
        }
      });
    },
    searchList () {
      //查询
      this.queryInfo.pageNum = 1;
      this.getrecordList();
    },
    // 删除
    deleteOrder(row){
      this.$confirm(this.$t('createOrder.createOrder68'), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.get(`aws/amazonShopRegister/remove?id=${row.id}`);
        if(res.data.code === 200) {
          this.$message({
            type: 'success',
            message: this.$t('createOrder.createOrder69')
          });
          await this.getrecordList()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('addr.addr40')
        });
      });
    },
    async getrecordList () {
      console.log(this.queryInfo);
      const { data: res } = await this.$http.get('aws/amazonShopRegister/list', { params: this.queryInfo });
      console.log(res);
      this.recordList = res.data;
    },
    // 状态
    moneyShow (moneyFlag) {
      switch (moneyFlag) {
        case 1:
          return this.$t('amazon.amazon21');
        case 0:
          return this.$t('amazon.amazon20');
      }
    },
  },
  created () {
    this.getrecordList();
  },
};
</script>

<style lang="less" scoped>
.role-page {
  font-size: 12px;
  .search-btn {
    height: 26px!important;
    line-height: 26px!important;
    padding: 0 12px !important;
    font-size: 11px!important;
    ::v-deep span{
      font-size: 11px!important;
    }
  }
  :deep(.el-table td.el-table__cell div) {
    font-size: 12px;
  }
}

.search-btn-wrap {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  gap: 10px;
  .search-btn {
    margin-right: 0 !important;
  }
}
.table-btn {
  justify-content: center;
}

.el-table .el-button--small {
  padding: 4px 10px;
}
.query-title {
  width: 100px;
}
.search-btn {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
</style>
